module.exports = __webpack_public_path__ + "c4d47f2427e5e998741a677e02079f49.png";